
import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { MapPin, Loader2 } from "lucide-react";
import { useToast } from "@/components/ui/use-toast";

interface LocationInputProps {
  value: string;
  onChange: (value: string) => void;
  error?: string;
}

const LocationInput = ({ value, onChange, error }: LocationInputProps) => {
  const { toast } = useToast();
  const [isLoading, setIsLoading] = useState(false);

  const getLocation = () => {
    setIsLoading(true);
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords;
          onChange(`${latitude}, ${longitude}`);
          setIsLoading(false);
          toast({
            title: "Localisation obtenue",
            description: "Votre position a été ajoutée au signalement",
          });
        },
        (error) => {
          console.error(error);
          setIsLoading(false);
          toast({
            title: "Erreur de localisation",
            description: "Impossible d'obtenir votre position",
            variant: "destructive",
          });
        }
      );
    } else {
      setIsLoading(false);
      toast({
        title: "Erreur",
        description: "La géolocalisation n'est pas supportée par votre navigateur",
        variant: "destructive",
      });
    }
  };

  return (
    <div>
      <label className="block text-sm font-medium text-gray-700 mb-1">
        Localisation
      </label>
      <div className="flex gap-4 items-center">
        <Input
          value={value}
          readOnly
          placeholder="Coordonnées GPS"
          className="flex-grow"
        />
        <Button
          type="button"
          onClick={getLocation}
          variant="outline"
          className="flex-shrink-0"
          disabled={isLoading}
        >
          {isLoading ? (
            <Loader2 className="mr-2 h-4 w-4 animate-spin" />
          ) : (
            <MapPin className="mr-2 h-4 w-4" />
          )}
          Localiser
        </Button>
      </div>
      {error && <p className="mt-1 text-sm text-red-500">{error}</p>}
    </div>
  );
};

export default LocationInput;
